import React, { FC, useEffect } from 'react'
import { Route, Switch, withRouter } from 'react-router-dom'

import { connect } from 'react-redux'
import Loader from 'uiKit/loaders/loader'
import { HOME_PATH } from 'configs'
import { setBrowserTabTitle } from 'helpers/setBrowserTabTitle'
import Descriptions from './pages/descriptions/Descriptions'
import { BotType } from 'models/BotType'
import { MatchType } from 'models/MatchType'

interface DataProps {
  activeBot: BotType
  match: MatchType
}

const Data: FC<DataProps> = ({ activeBot }) => {
  const pathRoute = `${HOME_PATH}/bot/:botId/data/`

  useEffect(() => {
    setBrowserTabTitle(`${activeBot?.name || 'Bot'} - Data`)
  }, [activeBot])

  if (!activeBot) return <Loader />

  return (
    <Switch>
      <Route exact path={pathRoute}>
        <Descriptions />
      </Route>
    </Switch>
  )
}

const mapStateToProps = (state: { activeBot: any }) => ({
  activeBot: state.activeBot,
})

export default withRouter(connect(mapStateToProps)(Data))
